import { makeStyles } from '@material-ui/core';

export default makeStyles(() => ({
  yearInput: {
    maxWidth: '320px',
  },
}));
